import React from "react";
import { View } from "@react-pdf/renderer";
import {
  ResumePDFText,
  ResumePDFDescription,
} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeWorkExperience } from "lib/redux/types";
import { TemplateSixPDFSectionWithSubsections as TemplateSixPDFSection } from "./common";

export const WorkExperience = ({
  heading,
  workExperiences,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  workExperiences: ResumeWorkExperience[];
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateSixPDFSection themeColor={themeColor} heading={heading}>
      {workExperiences.map(
        ({ company, jobTitle, startDate, endDate, descriptions }, idx) => {
          // Hide company name if it is the same as the previous company
          const hideCompanyName =
            idx > 0 && company === workExperiences[idx - 1].company;

          return (
            <View
              key={idx}
              style={{ marginTop: spacing[2], marginBottom: spacing[2] }}
              wrap={false} // Prevent individual experience items from splitting across pages
            >
              <View style={styles.flexRowBetween}>
                {!hideCompanyName && (
                  <ResumePDFText bold={true}>
                    {company}
                  </ResumePDFText>
                )}
                <ResumePDFText>
                  {startDate && endDate
                    ? `${startDate} - ${endDate}`
                    : startDate || endDate}
                </ResumePDFText>
              </View>
              <ResumePDFText>{jobTitle}</ResumePDFText>

              <View
                style={{
                  ...styles.flexCol,
                  marginBottom: spacing[2],
                }}
              >
                <ResumePDFDescription 
                  items={descriptions} 
                  enableHighlight={enableHighlight}
                  enableMistakeHighlight={enableMistakeHighlight}
                  section="experience"
                  itemIndex={idx}
                />
              </View>
            </View>
          );
        }
      )}
    </TemplateSixPDFSection>
  );
};
